import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FlagOutlineSVG = function FlagOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M27.5 5.1a1 1 0 00-1 0A16.7 16.7 0 0119.7 7a8.7 8.7 0 01-3.2-.8 13.3 13.3 0 00-5-1.2A12.7 12.7 0 006 6.3v-.6a2 2 0 10-2 0V29a1 1 0 002 0v-7.4a10.8 10.8 0 015.4-1.6 11.4 11.4 0 014.4 1 10.4 10.4 0 003.9 1 14.2 14.2 0 007.9-2.2 1 1 0 00.4-.8V6a1 1 0 00-.5-.9zM26 18.4a13 13 0 01-6.3 1.6 8.7 8.7 0 01-3.2-.8 13.3 13.3 0 00-5-1.2A12.7 12.7 0 006 19.3V8.5A11 11 0 0111.4 7a11.4 11.4 0 014.4 1 10.4 10.4 0 003.9 1A17.2 17.2 0 0026 7.6z"
  }));
};
FlagOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FlagOutlineSVG);